import { FontsEnum } from 'constants/enums/FontsEnum.ts';

export const errorPageStyles = {
	page: {
		height: '100dvh',
		width: '100%',

		gap: '32px',

		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
	},
	title: {
		fontSize: '120px',
		lineHeight: '120px',
		color: 'white',
		fontFamily: FontsEnum.INTER,
	},
	subtitle: {
		color: 'white',
		fontFamily: FontsEnum.INTER,
	},
	backToHomeButton: {
		minWidth: '260px',
		padding: '8px',
		borderRadius: '4px',
		textTransform: 'none',

		color: 'colors.dark6',
		backgroundColor: 'colors.systemGreen1',

		'&:hover': {
			backgroundColor: 'colors.systemGreen1',
		},
	},
};
